import { useEffect, useRef } from 'react';
import _ from 'lodash';
import ProfileStore from '../stores/ProfileStore';
import PointsStore from '../stores/PointsStore';
import PointsConstants from '../constants/PointsConstants';
import Analytics from 'arbitrip-common/client/analytics';
import { getAnalyticsPointsBalance, getUserDataSnapshotKey } from 'arbitrip-common/client/analytics/services/userDataSnapshotService';

const UserDataTracker = () => {
    const lastSnapshotKeyRef = useRef(null);
    useEffect(() => {
        const trackUserData = () => {
            const profile = ProfileStore.getProfile();
            if (!ProfileStore.isServerProfileLoaded() || _.isEmpty(profile)) {
                return;
            }
            // Wait for the loyalty balance so one load emits one event, not one without points and one with.
            if (_.get(profile, 'loyalty.enabled', false) && PointsStore.getStatus() === PointsConstants.STATUS.BUSY) {
                return;
            }

            const points_balance = getAnalyticsPointsBalance(PointsStore.getPoints());
            const snapshotKey = getUserDataSnapshotKey(profile, points_balance);
            if (snapshotKey === lastSnapshotKeyRef.current) {
                return;
            }
            lastSnapshotKeyRef.current = snapshotKey;

            Analytics.actions.user.userDataUpdated(profile, _.isUndefined(points_balance) ? {} : { points_balance });
        };

        ProfileStore.addChangeListener(trackUserData);
        PointsStore.addChangeListener(trackUserData);
        trackUserData();

        return () => {
            ProfileStore.removeChangeListener(trackUserData);
            PointsStore.removeChangeListener(trackUserData);
        };
    }, []);

    return null;
};

export default UserDataTracker;
